__webpack_require__.p = "/app/group-xm/";